// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (max-width:47.99em){.c-contact-button{opacity:1!important;transform:translateX(-50%)!important;transition-duration:.15s!important;transition-duration:.3s!important;transition-property:all!important;transition-timing-function:cubic-bezier(.4,0,.2,1)!important}.c-contact-button.scrolling{opacity:0!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
